import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import {
  Control,
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import {FontIcon} from 'components';
import {useTheme} from '@mui/material';

interface FeedbackRatingFieldProps<T extends FieldValues>
  extends UseControllerProps<T> {
  control: Control<T>;
}

const radoioStars = Array(5)
  .fill({})
  .map((item, i) => {
    return {...item, rating: i + 1};
  });

export const FeedbackRatingField = <T extends FieldValues>({
  control,
  name,
  ...rest
}: FeedbackRatingFieldProps<T>) => {
  const {field} = useController({
    name,
    control,
  });
  const theme = useTheme();

  return (
    <FormControl
      {...rest}
      id="radio-group"
      style={{width: '100%', alignItems: 'center'}}>
      <RadioGroup
        row
        aria-labelledby="feedback-radio-title"
        name={field.name}
        value={field.value}
        onChange={field.onChange}
        ref={field.ref}>
        {radoioStars.map((radioStar, i) => {
          const highlightSelectedRatingAndBefore =
            field.value >= radioStar.rating;
          const iconSize = 'xl';
          return (
            <FormControlLabel
              key={radioStar.rating}
              value={radioStar.rating}
              sx={{margin: 0}}
              aria-label={(i + 1).toString()}
              control={
                <Radio
                  icon={
                    <FontIcon
                      icon={[
                        `${highlightSelectedRatingAndBefore ? 'fas' : 'far'}`,
                        'star',
                      ]}
                      size={iconSize}
                      color={
                        highlightSelectedRatingAndBefore
                          ? theme.palette.primary.main
                          : undefined
                      }
                    />
                  }
                  checkedIcon={
                    <FontIcon
                      icon={['fas', 'star']}
                      size={iconSize}
                      color={theme.palette.primary.main}
                    />
                  }
                />
              }
              label={undefined}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};
